import { SearchOptions } from "@pro/_services";

import { constants } from "@common/_constants";
import { Routing } from "@common/_constants/";
import { ErrorService } from "@common/_services";
import { refetch } from "@common/_services/refetch";

export const MessageService = {
    unreadCount,
    markReadStatus,
    getRecipients,
    search,
    send,
};

function search(options: SearchOptions, abortSignal: AbortSignal) {
    const url = `${constants.GlobalConfig.apiUrl}/pro/v2/messagesearch`;
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
        body: JSON.stringify(options),
    };
    return refetch(url, settings)
        .then(resp => ErrorService.handleErrors(resp))
        .then(response => response.json())
        .then(json => json.result);
}

function unreadCount(abortSignal: AbortSignal) {
    const requestOptions: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };
    return refetch(Routing.Api.Pro.Messages.UNREAD_COUNT, requestOptions)
        .then(resp => ErrorService.handleErrors(resp))
        .then(resp => resp.json())
        .then(json => json.result);
}

function markReadStatus(id, status) {
    const url = `${constants.GlobalConfig.apiUrl}/pro/v2/messages/${id}/read/${status}`;
    const settings: RequestInit = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
    };
    return refetch(url, settings)
        .then(resp => ErrorService.handleErrors(resp))
        .then(response => response.json())
        .then(json => json.result);
}

function getRecipients(contextJobId, contextUserId, messageId, abortSignal: AbortSignal) {
    const jobIdFormatted = contextJobId ? `/${contextJobId}` : "/0";
    const userIdFormatted = contextUserId ? `/${contextUserId}` : "/0";
    const msgIdFormatted = messageId ? `/${messageId}` : "/0";

    const url = `${
        constants.GlobalConfig.apiUrl
    }/pro/v2/messages/to${jobIdFormatted}${userIdFormatted}${msgIdFormatted}`;
    const settings: RequestInit = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        signal: abortSignal,
    };

    return refetch(url, settings)
        .then(resp => ErrorService.handleErrors(resp))
        .then(response => response.json())
        .then(json => json.result);
}

function send(message) {
    const url = `${constants.GlobalConfig.apiUrl}/pro/v2/messages`;
    const settings: RequestInit = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(message),
    };
    return refetch(url, settings)
        .then(resp => ErrorService.handleErrors(resp))
        .then(response => response.json())
        .then(json => json.result);
}
